import { erpApi } from "@/shared/axios"
import { urlBackend } from "@/shared/constants"
import { AlertSeverityEnum, UseFetchEnabledParams, UseMutationsParams } from "@/shared/interfaces"
import { IAgendaCorporativoResp, IAgendaCorporativo } from "@/shared/interfaces/erp/agenda_corporativo"
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils"
import { useUiStore } from "@/store/ui"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"


const { get, post, put } = erpApi()

//UseFetchEnabledParams<GetAgendamientosParams> 

//  params?: GetAgendaCorporativaParams,
//  enabled = true


export const useGetAgendaCorporativas = ({
  enabled = true,
  params
}: UseFetchEnabledParams<GetAgendaCorporativaParams>
) => {
  return useQuery({
    queryKey: ['agendacorporativa', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getAgendaCorporativas(params);
    },
    enabled,
    refetchOnWindowFocus: false,
  })
}
export const getAgendaCorporativas = async (params?: GetAgendaCorporativaParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<IAgendaCorporativoResp>(`${urlBackend}api/v1/agendacorporativa/?${queryParams}`, true)
}

export const useGetAgendaCorporativaById = (id: string) => {
  return useQuery({
    queryKey: ['agendacorporativa', id],
    queryFn: async () => {
      return getAgendaCorporativaById(id)
    }
  })
}

export const usePostAgendamientoCorporativo = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,

}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: createAgendaCorporativa,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendaCorporativa'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);
      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Agenda Corporativa creado correctamente', AlertSeverityEnum.success
        )
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnErrorUrl || ''));
      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false)
    }
  })
}

export const usePutAgendaCorporativa = ({
  navigate,
  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: putAgendaCorporativa,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendacorporativa'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert &&
        setAlert(true, customSuccessMessage ?? 'Agenda Corporativa actualizada correctamente', AlertSeverityEnum.success)
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));
      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false)
    }
  })
}
///axios

export type GetAgendaCorporativaParams = Partial<IAgendaCorporativo> & {
  page?: number,
  page_size?: number,
}
export type CreateAgendaCorporativaParams = Omit<IAgendaCorporativo, 'id_agenda_corporativa'>;
export type UpdateAgendaCorporativaParams = {
  id: string
  data: CreateAgendaCorporativaParams
}


export const getAgendaCorporativaById = async (id: string) => {
  try {
    return await get<IAgendaCorporativo>(`${urlBackend}api/v1/agendacorporativa/${id}/`, true);
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const createAgendaCorporativa = async (data: Partial<CreateAgendaCorporativaParams>) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);
  return post<IAgendaCorporativo>(`${urlBackend}api/v1/agendacorporativa/`, data, true);
}

export const putAgendaCorporativa = async ({ id, data }: UpdateAgendaCorporativaParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true)
  return put<IAgendaCorporativo>(`${urlBackend}api/v1/agendacorporativa/${id}/`, data, true)
}